export const removeModalClass = (modalId) => {
  var modal = document.getElementById(modalId);
  modal.classList.remove("show");
  modal.setAttribute("aria-hidden", "true");
  // get modal backdrop
  const modalopen = document.getElementsByClassName("modal-open");
  const modalBackdrops = document.getElementsByClassName("modal-backdrop");
  modalBackdrops[0].parentNode.removeChild(modalBackdrops[0]);
  while (modalopen.length > 0) {
    modalopen[0].classList.remove("modal-open");

    document.getElementById("justo").style.paddingRight = "";
  }

  window.document.getElementById(modalId).style.display = "none";
};
